import dayjs from 'dayjs'
import { _basalRateBaseSettingInfosFromValueArray } from '@u/reportHelperPump'

export function _groupArrays(_list = [], oneGroupNum = 1) {
  let list = _list.slice()
  const l = list.length
  if (!l) {
    return []
  }
  
  const groupsNum = Math.floor(l / oneGroupNum)
  const restNum = l % oneGroupNum
  
  const rst = []
  
  let i = 1
  let r = list
  
  do {
    list = r
    
    r = list.splice(oneGroupNum)
    
    rst.push(list)
    i++
  } while (i <= groupsNum)
  
  if (restNum) {
    rst.push(r)
  }
  
  return rst
}

export function _f1(orderNum) {
  const { sortedBasalRateBaseSetting = [] } = this
  const tmp = sortedBasalRateBaseSetting[orderNum - 1]
  if (!tmp) return {}
  return tmp
}
export function _f2(orderNum) {
  const k = `basalRateBase${orderNum}`
  const base = this[k]
  const name = (base.settingName || ' ')
  const isActive = `${base.isActive}`.trim() === '0' // isActive是0，意味着是active的
  return isActive ? `${name}(${this.$t('Active')})` : `${name}`
}
export function _f3(orderNum) {
  const k = `basalRateBase${orderNum}`
  const base = this[k]
  const { basalRateBaseSettingRowsMax } = this
  const { valueArray = '' } = base
  const rst = _basalRateBaseSettingInfosFromValueArray(valueArray, k)
  const l = rst.length
  const num = Math.ceil(l / basalRateBaseSettingRowsMax)
  if (l - basalRateBaseSettingRowsMax > 0) {
    // 分成多列展示
    const all = rst.slice()
    
    const nr = []
    
    rst.splice(basalRateBaseSettingRowsMax)
    const firstColumns = rst
    
    const startOfDay = dayjs().startOf('day')
    const fmt = 'HH:mm'
    
    firstColumns.forEach((obj, i) => {
      if (i < basalRateBaseSettingRowsMax) {
        if (num >= 2) {
          // 计算column2, column3
          const index = i + basalRateBaseSettingRowsMax * 1
          const data = all[index] || { isEmpty: true }
          
          const start = startOfDay.add(data.start, 'hour').format(fmt)
          let end = startOfDay.add(data.end, 'hour').format(fmt)
          
          if (end === '00:00') {
            end = '24:00'
          }
          if (data && data.isEmpty !== true) {
            Object.assign(obj, {
              column2: `${start}-${end}`,
              column3: `${data.value ? data.value : ''}`,
              value2: data.value,
              start2: data.start,
              end2: data.end
            }) 
          } 
        }
        
        if (num >= 3) {
          // 计算column4, column5
          const index = i + basalRateBaseSettingRowsMax * 2
          const data = all[index] || { isEmpty: true }
          
          const start = startOfDay.add(data.start, 'hour').format(fmt)
          let end = startOfDay.add(data.end, 'hour').format(fmt)
          
          if (end === '00:00') {
            end = '24:00'
          }
          if (data && data.isEmpty !== true) {
            Object.assign(obj, {
              column4: `${start}-${end}`,
              column5: `${data.value ? data.value : ''}`,
              value3: data.value,
              start3: data.start,
              end3: data.end
            }) 
          } 
        }
        
        if (num > 3) {
          // 计算column6, column7
          const index = i + basalRateBaseSettingRowsMax * 3
          const data = all[index] || { isEmpty: true }
          
          const start = startOfDay.add(data.start, 'hour').format(fmt)
          let end = startOfDay.add(data.end, 'hour').format(fmt)
          
          if (end === '00:00') {
            end = '24:00'
          }
          if (data && data.isEmpty !== true) {
            Object.assign(obj, {
              column6: `${start}-${end}`,
              column7: `${data.value ? data.value : ''}`,
              value4: data.value,
              start4: data.start,
              end4: data.end
            }) 
          } 
        }
        
        nr.push(obj)
      }
    })
    
    return nr
  }
  
  return rst
}
export function _f4(orderNum) {
  const k = `basalRateBase${orderNum}`
  const base = this[k]
  const { basalRateBaseSettingRowsMax } = this
  const { valueArray = '' } = base
  const rst = _basalRateBaseSettingInfosFromValueArray(valueArray, k)
  const l = rst.length
  const num = Math.ceil(l / basalRateBaseSettingRowsMax)
  
  return num === 2
}
export function _f5(orderNum) {
  const k = `basalRateBase${orderNum}`
  const base = this[k]
  const { valueArray = '' } = base
  const { basalRateBaseSettingRowsMax } = this
  const rst = _basalRateBaseSettingInfosFromValueArray(valueArray, k)
  const l = rst.length
  const num = Math.ceil(l / basalRateBaseSettingRowsMax)
  
  return num === 3
}

export function _f6(orderNum) {
  const k = `basalRateBase${orderNum}`
  const base = this[k]
  const { basalRateBaseSettingRowsMax } = this
  const { valueArray = '' } = base
  const rst = _basalRateBaseSettingInfosFromValueArray(valueArray, k)
  const l = rst.length
  const num = Math.ceil(l / basalRateBaseSettingRowsMax)
  
  return num > 3
}

export function _f7(orderNum) {
  const k = `basalRateBase${orderNum}`
  const base = this[k]
  const { valueArray = '' } = base
  const rst = _basalRateBaseSettingInfosFromValueArray(valueArray, k)
  
  let total = 0
  rst.forEach(gap => {
    const { start, end, value } = gap
    const hourV = value
    const duration = end - start
    total += (hourV * duration)
  })
  
  return total.toFixed(1) + 'U/' + this.$t('day')
}
